module.exports = __webpack_public_path__ + "img/بابايا-صورة.fd0941df.png";